import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf, NgFor, CurrencyPipe } from '@angular/common';
import { ProductService } from '../../../../core/services/product.service';
import { CartService } from '../../../../core/services/cart.service';
import { QuoteService } from '../../../../core/services/quote.service';

@Component({
  selector: 'app-producto',
  standalone: true,
  imports: [NgIf, NgFor, CurrencyPipe],
  templateUrl: './producto.component.html',
  styleUrl: './producto.component.scss'
})
export class ProductoComponent {
  private route = inject(ActivatedRoute);
  ps: any = inject(ProductService);
  cart = inject(CartService);
  quote = inject(QuoteService);

  p = this.ps.bySlug(this.route.snapshot.paramMap.get('slug')!);
  active = 0;

  setActive(i: number) { this.active = i; }
}
